import {IPageObserverEntry} from '../../Utilities/Helper.client';
import {toggleStickyPriceCompareButton} from '../../Components/StickyButtonPriceCompare/StickyButtonPriceCompare.client';

export const getFooterLinksObservableEntry = (): IPageObserverEntry | null => {
    const target: HTMLElement | null = document.querySelector('.FooterLinks');

    if (target === null) {
        return target;
    }

    return {
        element: target,
        callback: (entry: IntersectionObserverEntry): void => {
            toggleStickyPriceCompareButton(entry);
        }
    }
};

export const showCurrentYear = () => {
    const currentYear: number = new Date().getFullYear();
    const element: HTMLElement | null = document.querySelector('.footerCurrentYear');

    if (element === null) {
        return;
    }

    element.innerHTML = `${currentYear}`;
}